import ICON__download_solid from '@/assets/icons/font_awesome/download-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { FN_IMAGE__download } from '../../_base/_buttons/FN_IMAGE__download';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_GRAPH__BUTTON__list_images_download({ field }: PROPS) {
  /*
   * STORE
   */
  /*
   * STATE
   */

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let promises = [];

    let fields = field.items;
    fields = fields.filter(field => !field.is_stub()); //skip stubs
    fields = fields.filter(field => field.image__is_initialized); //keep initialized

    for (let field of fields) {
      promises.push(FN_IMAGE__download(field.asset.url_relative, field.asset.hash_sha256_content.remove_string_protocol()));
    }

    await Promise.all(promises);
  }

  /*
   * METHODS
   */

  /*
   * HTML
   */

  if (!field.images_are_initialized()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (field.items.is_empty()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;

  return (
    <UI_PRIMITIVE__button size={'square-6'} variant={'no-border-on-bar'} {...{ onClick }}>
      <ICON__download_solid className="!size-3" />
    </UI_PRIMITIVE__button>
  );
}
